module.exports = __webpack_public_path__ + "static/media/2015_conf_Digital_Physical_Product_Startups.3c93a20e.png";